import React from "react";
import { Button } from "./ui/button";
import { FileText } from "lucide-react";

// TODO(Thomas) : remplacer par les URLs définitives une fois les documents fournis.
const STATUTS_URL = "https://imagigeeks.org/assets/Statuts.pdf";
const REGLEMENT_BENEVOLES_URL = "https://imagigeeks.org/assets/Reglement-Benevoles.pdf";

const AssociationDocs = ({ isBenevole = false }) => {
  const docs = [
    { label: "Statuts de l'association", href: STATUTS_URL },
    // Le règlement des bénévoles ne concerne que les inscriptions arrivées via le lien bénévole.
    ...(isBenevole ? [{ label: "Règlement des bénévoles", href: REGLEMENT_BENEVOLES_URL }] : []),
  ];

  return (
  <div className="flex flex-col gap-1.5">
    <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest">
      Autres documents utiles
    </p>
    <div className="flex flex-wrap gap-x-4 gap-y-1.5">
      {docs.map((doc) => (
        <Button
          key={doc.label}
          type="button"
          variant="link"
          size="sm"
          className="gap-1.5 text-primary h-auto p-0 text-xs"
          onClick={() => window.open(doc.href, "_blank")}
        >
          <FileText className="h-3.5 w-3.5" />
          {doc.label}
        </Button>
      ))}
    </div>
  </div>
  );
};

export default AssociationDocs;
